import { useMutation, useQuery } from "react-query";
import { getCarrierAgreement } from "../../../../../actions/CarrierAgreementMgmt/Reports/index";

const useCarrierAgreementLinkAndCommision = ({
  searchInputsData,
  enableSearch = false,
}) => {
  return useQuery(
    ["GetFilteredCarrierAgreement", searchInputsData],
    getCarrierAgreement,
    {
      enabled: enableSearch,
    }
  );
};

export default useCarrierAgreementLinkAndCommision;
